// Shared-component strings, namespaced as 'components.<componentName>.<key>'.
export default {
  'components.cleanTextContextMenu.copy': 'Salin teks bersih',
  'components.cleanTextContextMenu.copied': 'Teks bersih disalin',
  'components.cleanTextContextMenu.failed': 'Tidak dapat menyalin teks. Silakan coba lagi.',
  'components.chatWidget.processingTooltip': 'Chat akan tersedia setelah pemrosesan selesai',
  'components.chatWidget.messageCopied': 'Pesan berhasil disalin!',
  'components.chatWidget.copyMessageFailed': 'Gagal menyalin pesan',
  'components.chatWidget.header.title': 'Chat',
  'components.chatWidget.emptyState.title': 'Ada yang bisa dibantu?',
  'components.chatWidget.inputPlaceholder': 'Ketik pesan...',
  'components.chatWidget.showMoreLines': 'Tampilkan lebih banyak ({count} baris)',
  'components.chatWidget.invalidFileUrl': 'URL file tidak valid atau tidak ditemukan',
  'components.chatWidget.fileDownloadedSuccessfully': 'File berhasil diunduh',
  'components.chatWidget.fileDownloadFailed': 'Gagal mengunduh file: {message}',
  'components.chatWidget.unnamedFile': 'file',
  'components.chatWidget.attachmentImageAlt': 'lampiran',
  'components.checklistCard.heading': 'Checklist',
  'components.downloadLoadingMask.downloading': 'Mengunduh...',
  'components.emlViewer.fromLabel': 'Dari:',
  'components.emlViewer.toLabel': 'Kepada:',
  'components.emlViewer.ccLabel': 'Cc:',
  'components.emlViewer.dateLabel': 'Tanggal:',
  'components.emlViewer.attachmentsLabel': 'Lampiran:',
  'components.filesSidePanel.favoritesButton': 'Favorit',
  'components.filesSidePanel.historyButton': 'Riwayat',
  'components.filesSidePanel.untitledPlaceholder': '(Tanpa Judul)',
  'components.filesSidePanel.membersPopoverTitle': 'Anggota',
  'components.filesSidePanel.ownerTag': 'Pemilik',
  'components.filesSidePanel.modifyGroupTooltip': 'Ubah Grup',
  'components.filesSidePanel.privateGroupWarningTooltip': 'Kurang aman: Terlihat oleh grup Anda.',
  'components.filesSidePanel.publicWarningTooltip': 'Sangat tidak aman: Terlihat oleh semua orang.',
  'components.filesSidePanel.sortByDateLabel': 'Urutkan Berdasarkan Tanggal (Baru ke Lama)',
  'components.filesSidePanel.sortAlphabeticallyLabel': 'Urutkan Berdasarkan Abjad (A-Z)',
  'components.gettingStartedTour.insiderHero.openLinkLabel': 'Buka A&GEL Insider',
  'components.gettingStartedTour.insiderHero.logoAlt': 'A&GEL Insider',
  'components.gettingStartedTour.insiderHero.heroTitle': 'Mempelajari alat baru butuh waktu',
  'components.gettingStartedTour.insiderHero.basicsCard.cta': 'Mulai dari Dasar',
  'components.gettingStartedTour.insiderHero.learnMoreCard.cta': 'Pelajari Lebih Lanjut',
  'components.gettingStartedTour.insiderHero.whatsNewCard.cta': 'Yang Baru',
  'components.gettingStartedTour.insiderHero.marinaAlt': 'Siluet marina',
  'components.gettingStartedTour.insiderHero.featuredArticleLabel': 'Artikel Unggulan',
  'components.gettingStartedTour.insiderHero.filesUpload.title': 'Unggah File',
  'components.gettingStartedTour.insiderHero.filesUpload.cta': 'Lihat Selengkapnya',
  'components.gettingStartedTour.allCompleted.title': 'Anda telah menyelesaikan seluruh tur A&GEL!',
  'components.gettingStartedTour.allCompleted.redoButton': 'Ulangi tur',
  'components.gettingStartedTour.heading': 'Memulai',
  'components.gettingStartedTour.tourStyles.stepIndicator': 'Langkah {current} dari {total}',
  'components.gettingStartedTour.tourStyles.nextDefault': 'Berikutnya →',
  'components.gettingStartedTour.chatTour.step2.title': 'Berikut dokumen yang telah dimuat.',
  'components.gettingStartedTour.chatTour.step2.nextLabel': 'Tutup & Lanjutkan →',
  'components.gettingStartedTour.chatTour.completeModal.title': 'Kerja bagus!',
  'components.gettingStartedTour.tourComplete.completeButton': 'Selesai',
  'components.gettingStartedTour.tourComplete.continueButton': 'Lanjutkan ke {title} →',
  'components.gettingStartedTour.playbookTour.completeModal.title': 'Kerja bagus!',
  'components.gettingStartedTour.playbookTour.step1.openingLabel': 'Membuka…',
  'components.gettingStartedTour.playbookTour.step1.openSampleLabel': 'Buka contoh →',
  'components.gettingStartedTour.playbookTour.step2.item1': '• Kepemilikan bersama KI (Klausul 17)',
  'components.gettingStartedTour.playbookTour.step3.title': 'Klik Send untuk membuat amandemen.',
  'components.gettingStartedTour.reviewTour.completeModal.title': 'Mengesankan!',
  'components.gettingStartedTour.reviewTour.step15.nextLabel': 'Selesai',
  'components.gettingStartedTour.scribeTour.completeModal.title': 'Kerja bagus!',
  'components.gettingStartedTour.scribeTour.step2.title': 'Bahasa diatur ke "Deteksi Otomatis".',
  'components.gettingStartedTour.scribeTour.step7.title': 'Klik Edit untuk mengubah transkrip.',
  'components.gettingStartedTour.searchTour.completeModal.title': 'Kerja bagus!',
  'components.gettingStartedTour.tourButton.label': 'Tur',
  'components.gettingStartedTour.tourCompleteModal.features.chat': 'Ajukan pertanyaan di Chat',
  'components.gettingStartedTour.tourCompleteModal.features.search': 'Cari di berbagai dokumen',
  'components.gettingStartedTour.tourCompleteModal.features.scribe': 'Transkripsikan dengan Scribe',
  'components.gettingStartedTour.tourCompleteModal.features.review': 'Analisis dengan Review',
  'components.gettingStartedTour.tourCompleteModal.title': 'Anda sudah siap!',
  'components.gettingStartedTour.tourCompleteModal.progressText': '5 dari 5 fitur telah selesai',
  'components.gettingStartedTour.tourCompleteModal.ctaButton': 'Mulai Menggunakan A&GEL →',
  'components.gettingStartedTour.tourCompleteModal.userGuidePrefix': 'Butuh bantuan? Kunjungi ',
  'components.gettingStartedTour.tourCompleteModal.userGuideLabel': 'Panduan Pengguna',
  'components.lLMMetrics.status.fast': 'CEPAT',
  'components.lLMMetrics.status.slow': 'LAMBAT',
  'components.lLMMetrics.status.busy': 'SIBUK',
  'components.lLMMetrics.status.pending': 'TERTUNDA',
  'components.lLMMetrics.status.loading': 'MEMUAT',
  'components.lLMMetrics.metricBox.defaultChartLabel': 'Nilai',
  'components.management.passwordModal.usernameColumn': 'Nama Pengguna',
  'components.management.passwordModal.passwordColumn': 'Kata Sandi',
  'components.menuPanel.untitledItem': '(Tanpa Judul)',
  'components.menuPanel.renameFailed': 'Gagal mengganti nama',
  'components.menuPanel.deleteConfirm.title': 'Hapus Item Riwayat',
  'components.filesSidePanel.firmWideWarningTooltip':
    'Sangat tidak aman: Terlihat oleh seluruh firma Anda.',
  'components.gettingStartedTour.insiderHero.basicsCard.copy':
    'Semua yang Anda butuhkan sejak hari pertama.',
  'components.gettingStartedTour.insiderHero.learnMoreCard.copy':
    'Fitur lanjutan jika Anda ingin lebih jauh.',
  'components.gettingStartedTour.insiderHero.whatsNewCard.copy':
    'Peluncuran dan pembaruan terbaru.',
  'components.gettingStartedTour.insiderHero.filesUpload.description':
    'Unggah seluruh file email ke A&GEL, termasuk lampirannya, dan kelola seperti dokumen lainnya.',
  'components.gettingStartedTour.chatTour.step1.title':
    'Kami telah memuat contoh NDA untuk Anda. Klik Context untuk melihatnya.',
  'components.gettingStartedTour.chatTour.step1.text':
    'Di sinilah Anda mengelola dokumen yang dijadikan referensi A&GEL saat menjawab.',
  'components.gettingStartedTour.chatTour.step2.text':
    'Anda dapat mengunggah file atau memilih dari Vault Anda. Tutup panel jika sudah siap.',
  'components.gettingStartedTour.chatTour.step3.title':
    'Kami telah menyiapkan pertanyaan untuk Anda. Klik Send untuk bertanya tentang NDA ini.',
  'components.gettingStartedTour.chatTour.sampleQuestionDisplay':
    'Apa saja kewajiban kerahasiaan dalam perjanjian ini?',
  'components.gettingStartedTour.chatTour.step4.title':
    'Jawaban yang bagus! Sekarang klik nomor referensi (misalnya [1]) untuk melihat dokumen sumbernya.',
  'components.gettingStartedTour.chatTour.step4.text':
    'Referensi mengarah kembali ke bagian pasti dari dokumen yang digunakan AI.',
  'components.gettingStartedTour.chatTour.completeModal.description':
    'Anda telah mengajukan pertanyaan pertama di Chat dan mendapatkan jawaban bersitasi.',
  'components.gettingStartedTour.tourComplete.progressText':
    '{completedCount} dari 5 fitur telah selesai',
  'components.gettingStartedTour.playbookTour.completeModal.description':
    'Anda telah menerapkan amandemen dengan Workstudio.',
  'components.gettingStartedTour.playbookTour.step1.title':
    'Kami telah memuat contoh perjanjian vendor yang memerlukan amandemen.',
  'components.gettingStartedTour.playbookTour.step1.text':
    'Anda berperan sebagai vendor (Pand.ai) yang meminta persyaratan yang lebih menguntungkan dari klien.',
  'components.gettingStartedTour.playbookTour.step2.title':
    'Kami telah menyusun 3 permintaan amandemen:',
  'components.gettingStartedTour.playbookTour.step2.item2':
    '• Tambahkan periode perbaikan 14 hari (Klausul 8)',
  'components.gettingStartedTour.playbookTour.step2.item3':
    '• Persempit larangan bersaing (Klausul 27)',
  'components.gettingStartedTour.playbookTour.step2.text':
    'Mode multi-langkah memproses setiap permintaan secara paralel untuk hasil yang lebih cepat.',
  'components.gettingStartedTour.playbookTour.step3.text':
    'A&GEL akan menampilkan perubahan yang dilacak (tracked changes) yang dapat Anda terima, tolak, atau unduh.',
  'components.gettingStartedTour.playbookTour.step4.title':
    'Berikut amandemen yang disusun A&GEL berdasarkan prompt Anda.',
  'components.gettingStartedTour.playbookTour.step4.text':
    'Setiap kartu menampilkan teks asli dan perubahan yang diusulkan.',
  'components.gettingStartedTour.playbookTour.step5.title':
    'Tinjau amandemen ini lalu terima atau tolak.',
  'components.gettingStartedTour.playbookTour.step5.text':
    'Anda dapat mengulangi langkah ini untuk sisanya nanti.',
  'components.gettingStartedTour.reviewTour.completeModal.description':
    'Anda telah membuat Question List dan meninjau dokumen dengannya.',
  'components.gettingStartedTour.reviewTour.step1.title':
    'Review menjawab pertanyaan Anda di berbagai dokumen menggunakan Question List.',
  'components.gettingStartedTour.reviewTour.step1.text':
    'Anda dapat membuat Question List sendiri atau menggunakan yang sudah ada.',
  'components.gettingStartedTour.reviewTour.step2.title':
    'Jelajahi Question List siap pakai berdasarkan kategori.',
  'components.gettingStartedTour.reviewTour.step3.title':
    'Mari buat Question List Anda sendiri. Klik di sini untuk memulai Question List baru.',
  'components.gettingStartedTour.reviewTour.step4.title':
    'Pilih kategori untuk mengatur daftar Anda.',
  'components.gettingStartedTour.reviewTour.step5.title':
    'Berikut beberapa contoh pertanyaan yang ditambahkan ke daftar Anda sebagai baris yang dapat diedit.',
  'components.gettingStartedTour.reviewTour.step6.title':
    'Pertanyaan Anda muncul di sini sebagai baris yang dapat diedit. Anda dapat menghapusnya kapan saja atau menambahkan bagian untuk mengelompokkannya.',
  'components.gettingStartedTour.reviewTour.step7.title':
    'Jelaskan tujuan daftar ini — sesuaikan dengan kebutuhan Anda.',
  'components.gettingStartedTour.reviewTour.step8.title':
    'Sesuaikan cara AI menjawab — nada, format, tingkat detail.',
  'components.gettingStartedTour.reviewTour.step9.title':
    'Simpan daftar Anda untuk digunakan pada dokumen.',
  'components.gettingStartedTour.reviewTour.step10.title':
    'Kami telah memuat beberapa contoh dokumen untuk Anda coba.',
  'components.gettingStartedTour.reviewTour.step10.text':
    'Question List Anda sudah siap dijalankan pada dokumen tersebut.',
  'components.gettingStartedTour.reviewTour.step11.title':
    'Klik Submit untuk menjalankan review pada semua dokumen.',
  'components.gettingStartedTour.reviewTour.step12.title':
    'Setiap baris adalah pertanyaan, setiap kolom adalah dokumen. Jawaban diekstrak secara otomatis.',
  'components.gettingStartedTour.reviewTour.step13.title':
    'Klik jawaban mana pun untuk melihat sumber persisnya.',
  'components.gettingStartedTour.reviewTour.step14.title':
    'Klik nomor referensi untuk langsung menuju bagian yang persis di dokumen sumber.',
  'components.gettingStartedTour.reviewTour.step15.title':
    'Itulah alur Review secara lengkap — sumber selalu bisa diakses hanya dengan satu klik. Anda telah selesai!',
  'components.gettingStartedTour.scribeTour.completeModal.description':
    'Anda telah mentranskripsikan audio dengan Scribe.',
  'components.gettingStartedTour.scribeTour.step1.title':
    'Pilih tujuan penggunaan transkripsi ini.',
  'components.gettingStartedTour.scribeTour.step1.text':
    'Ini membantu A&GEL memformat hasilnya. "Meeting Notes" sudah dipilih secara otomatis.',
  'components.gettingStartedTour.scribeTour.step2.text':
    'Anda juga dapat mengaktifkan Live Translation untuk melihat terjemahan secara real-time.',
  'components.gettingStartedTour.scribeTour.step3.title':
    'Klik tombol rekam, atau unggah file audio yang sudah ada.',
  'components.gettingStartedTour.scribeTour.step4.title':
    'Klik Stop saat Anda siap menyimpan transkrip.',
  'components.gettingStartedTour.scribeTour.step5.title':
    'Ketik nama untuk transkrip Anda, lalu klik Save.',
  'components.gettingStartedTour.scribeTour.step6.title':
    'Klik baris transkrip mana pun untuk memutar audio dari titik tersebut.',
  'components.gettingStartedTour.scribeTour.step7.text':
    'Perubahan Anda akan ditampilkan dengan warna emas.',
  'components.gettingStartedTour.scribeTour.step8.title':
    'Klik Save untuk menyimpan perubahan Anda.',
  'components.gettingStartedTour.scribeTour.step8.text':
    'Perubahan Anda ditampilkan dengan warna emas sebelum disimpan.',
  'components.gettingStartedTour.searchTour.completeModal.description':
    'Anda telah mencari di berbagai dokumen dan menemukan klausul yang relevan.',
  'components.gettingStartedTour.searchTour.step1.title':
    'Kami telah menyiapkan kueri pencarian untuk Anda.',
  'components.gettingStartedTour.searchTour.step1.text':
    'Klik Search atau tekan Enter untuk menemukan klausul yang cocok.',
  'components.gettingStartedTour.searchTour.step2.title':
    'Berikut hasil yang cocok dari NDA. Klik dokumen untuk melihat semua hasil yang cocok di dalamnya.',
  'components.gettingStartedTour.searchTour.step3.title':
    'Klik potongan mana pun untuk menuju bagian tersebut di dokumen.',
  'components.gettingStartedTour.searchTour.step3.text':
    'Di sebelah kiri Anda melihat kutipan yang cocok. Di sebelah kanan adalah dokumen lengkap dengan kata kunci yang disorot.',
  'components.gettingStartedTour.tourCompleteModal.features.playbook':
    'Terapkan amandemen di Workstudio',
  'components.gettingStartedTour.tourCompleteModal.subtitle':
    'Anda telah menyelesaikan tur A&GEL dan mempelajari cara:',
  'components.management.passwordModal.createHeader':
    'Anda berhasil membuat pengguna dengan kredensial berikut:',
  'components.management.passwordModal.emailChangeHeader':
    'Anda berhasil mengubah email pengguna. Kredensial baru di bawah ini:',
  'components.management.passwordModal.changePasswordNotice':
    '*Pengguna harus mengubah kata sandinya setelah login pertama',
  'components.menuPanel.deleteConfirm.content':
    'Apakah Anda yakin ingin menghapus item riwayat ini? Tindakan ini tidak dapat dibatalkan.',
  'components.addToMattersPopover.searchPlaceholder': 'Cari matter...',
  'components.addToMattersPopover.selectMattersLabel': 'Pilih matter:',
  'components.addToMattersPopover.updateError': 'Gagal memperbarui matter',
  'components.addToMattersPopover.updateSuccess': 'Matter berhasil diperbarui',
  'components.billingRequiredOverlay.manageBillingButton': 'Kelola tagihan',
  'components.billingRequiredOverlay.title': 'Tagihan diperlukan',
  'components.chat.contentOpenedInNewTab': 'Konten dibuka di tab baru',
  'components.chat.dataOpenedInNewTab': 'Data dibuka di tab baru',
  'components.chat.failedToFetchUrl': 'Gagal mengambil URL: {message}',
  'components.chat.failedToOpenNewTab': 'Gagal membuka tab baru',
  'components.chat.fileOpenedInNewTab': 'File dibuka di tab baru',
  'components.chat.htmlContentTitle': 'Konten HTML',
  'components.chat.jsonResponseTitle': 'Respons JSON',
  'components.chat.referenceDocumentFallback': 'Dokumen referensi',
  'components.chat.referencesCount': '{count} referensi',
  'components.chat.showMoreLines': 'Tampilkan lebih banyak ({count} baris)',
  'components.chat.sourcesCount': 'Sumber ({count})',
  'components.chat.textResponseTitle': 'Respons Teks',
  'components.chatWidget.closeChatAriaLabel': 'Tutup chat',
  'components.chatWidget.openChatAriaLabel': 'Buka chat',
  'components.chatWidget.waitingMessage.fetchingThatForYou': 'Sedang mengambilkannya untuk Anda...',
  'components.chatWidget.waitingMessage.justAMoment': 'Mohon tunggu sebentar...',
  'components.chatWidget.waitingMessage.letMeCheck': 'Biar saya periksa dulu...',
  'components.chatWidget.waitingMessage.thisWillJustTakeASecond':
    'Ini hanya akan memakan waktu sebentar...',
  'components.menuPanel.deleteConfirm.createdLabel': 'Dibuat:',
  'components.menuPanel.deleteFailed': 'Gagal menghapus item riwayat',
  'components.menuPanel.deleteSuccess': 'Item riwayat berhasil dihapus',
  'components.menuPanel.endOfListMessage': '- Ini akhir daftar -',
  'components.menuPanel.historyLabel': 'Riwayat',
  'components.menuPanel.searchHistoryButton': 'Cari Riwayat',
  'components.menuPanel.showAllButton': 'Tampilkan Semua',
  'components.menuPanel.showFavoritesButton': 'Tampilkan Favorit',
  'components.message.audiosLabel': 'Audio',
  'components.message.enhanceGpt.answerLabel': 'Jawaban',
  'components.message.enhanceGpt.modalTitle': 'Tingkatkan Respons GPT',
  'components.message.enhanceGpt.questionLabel': 'Pertanyaan: {question}',
  'components.message.enhanceGpt.successMessage': 'Respons baru berhasil dicatat',
  'components.message.imagesLabel': 'Gambar',
  'components.message.locationLabel': 'Lokasi',
  'components.message.postback.chatbotButtonFallback': 'Tombol Chatbot',
  'components.message.postback.clickedLabel': 'Diklik:',
  'components.message.stickerLabel': 'Stiker',
  'components.message.videosLabel': 'Video',
  'components.msgViewer.attachmentsLabel': 'Lampiran:',
  'components.msgViewer.fromLabel': 'Dari:',
  'components.msgViewer.toLabel': 'Kepada:',
  'components.pdfViewerWithHighlight.renderError': 'Gagal merender PDF',
  'components.promptSelector.actionOption.amend': 'Amandemen',
  'components.promptSelector.actionOption.draft': 'Draf',
  'components.promptSelector.actionOption.redFlagging': 'Penandaan Risiko',
  'components.promptSelector.actionOption.review': 'Tinjau',
  'components.promptSelector.actionOption.summarise': 'Ringkas',
  'components.promptSelector.actionPlaceholder': 'Tindakan',
  'components.promptSelector.audienceOption.group': 'Grup',
  'components.promptSelector.audienceOption.personal': 'Pribadi',
  'components.promptSelector.audienceOption.public': 'Publik',
  'components.promptSelector.audiencePlaceholder': 'Audiens',
  'components.promptSelector.authorLabel': 'Penulis',
  'components.promptSelector.copyError': 'Gagal menyalin prompt',
  'components.promptSelector.copySuccess': 'Prompt berhasil disalin!',
  'components.promptSelector.documentsAttached': '{count} dokumen akan dilampirkan',
  'components.promptSelector.noResultsFiltered': 'Tidak ada prompt yang sesuai dengan filter Anda',
  'components.promptSelector.promptLabel': 'Prompt',
  'components.promptSelector.promptLoaded': 'Prompt telah dimuat!',
  'components.promptSelector.selectPromptHint': 'Pilih prompt untuk memuatnya ke kolom input',
  'components.promptSelector.startTyping': 'Mulai mengetik untuk mencari prompt',
  'components.promptSelector.tagsLabel': 'Tag',
  'components.promptSelector.untitledPrompt': 'Prompt Tanpa Judul',
  'components.promptSelector.usePromptButton': 'Gunakan Prompt',
  'components.questionListSelection.accessFirmTag': 'Firma',
  'components.questionListSelection.accessGroupTag': 'Grup pribadi',
  'components.questionListSelection.accessPublicTag': 'Publik',
  'components.questionListSelection.audienceOptionPersonal': 'Pribadi',
  'components.questionListSelection.audienceOptionPublic': 'Publik',
  'components.questionListSelection.filterByAudiencePlaceholder': 'Filter berdasarkan Audiens',
  'components.questionListSelection.filterByAuthorPlaceholder': 'Filter berdasarkan Penulis',
  'components.questionListSelection.questionCount': '{count} Pertanyaan',
  'components.questionListSelection.sortMostPopular': 'Urutkan: Paling Populer',
  'components.questionListSelection.sortNameAsc': 'Urutkan: Nama A-Z',
  'components.questionListSelection.sortNameDesc': 'Urutkan: Nama Z-A',
  'components.questionListSelection.tourButton': 'Tur',
  'components.questionListSelection.tourTooltip': 'Ikuti tur',
  'components.questionListSelection.untitledQuestionList': '(Tanpa Judul)',
  'components.questionListSelection.viewAll': 'Lihat Semua',
  'components.questionListSelection.viewLess': 'Lihat Lebih Sedikit',
  'components.reference.addColumn': 'Tambah Kolom',
  'components.reference.addCommentPlaceholder': 'Tambahkan komentar...',
  'components.reference.addRow': 'Tambah Baris',
  'components.reference.answerLabel': 'Jawaban: ',
  'components.reference.chatWithSelectedOutput': 'Chat dengan Output Terpilih',
  'components.reference.commentAddedSuccess': 'Komentar berhasil ditambahkan',
  'components.reference.commentDeletedSuccess': 'Komentar berhasil dihapus',
  'components.reference.commentUpdatedSuccess': 'Komentar berhasil diperbarui',
  'components.reference.deleteComment.description':
    'Apakah Anda yakin ingin menghapus komentar ini?',
  'components.reference.deleteComment.title': 'Hapus komentar',
  'components.reference.deleteOwnCommentsOnly': 'Anda hanya dapat menghapus komentar Anda sendiri',
  'components.reference.detailedView': 'Tampilan Detail',
  'components.reference.documentsHeader': 'Dokumen',
  'components.reference.exitSelectMode': 'Keluar',
  'components.reference.explanationLabel': 'Penjelasan',
  'components.reference.failedToAddComment': 'Gagal menambahkan komentar',
  'components.reference.failedToDeleteComment': 'Gagal menghapus komentar',
  'components.reference.failedToUpdateComment': 'Gagal memperbarui komentar',
  'components.reference.inverse': 'Kebalikan',
  'components.reference.openCellDetails': 'Buka detail sel',
  'components.reference.pleaseEnterComment': 'Silakan masukkan komentar',
  'components.reference.resetView': 'Atur Ulang Tampilan',
  'components.reference.selectCellAriaLabel': 'Pilih sel',
  'components.reference.selectCells': 'Pilih Sel',
  'components.reference.selectDocumentColumnAriaLabel': 'Pilih kolom dokumen',
  'components.reference.selectDocumentRowAriaLabel': 'Pilih baris dokumen',
  'components.reference.selectQuestionColumnAriaLabel': 'Pilih kolom pertanyaan',
  'components.reference.selectQuestionRowAriaLabel': 'Pilih baris pertanyaan',
  'components.reference.showAllColumns': 'Tampilkan Semua Kolom',
  'components.reference.showAllRows': 'Tampilkan Semua Baris',
  'components.reference.summaryView': 'Tampilan Ringkasan',
  'components.reference.exactQuote': 'Kutipan Persis',
  'components.reference.exactQuoteView': 'Tampilan Kutipan Persis',
  'components.reference.timeAgo.daysAgo': '{count, plural, one {# hari lalu} other {# hari lalu}}',
  'components.reference.timeAgo.hoursAgo': '{count, plural, one {# jam lalu} other {# jam lalu}}',
  'components.reference.timeAgo.justNow': 'Baru saja',
  'components.reference.unknownAuthor': 'Tidak diketahui',
  'components.reference.updateOwnCommentsOnly':
    'Anda hanya dapat memperbarui komentar Anda sendiri',
  'components.reference.verifiedLabel': 'Terverifikasi',
  'components.reference.verifyLabel': 'Verifikasi',
  'components.referencePopover.failedToOpenFile': 'Gagal membuka file',
  'components.referencePopover.failedToOpenNewTab': 'Gagal membuka tab baru',
  'components.referencePopover.fileLinkUnavailable': 'Tautan file tidak tersedia',
  'components.referencePopover.openInNewTab': 'Buka dokumen di tab baru ↗',
  'components.rightContent.angelTeamsButton.label': 'Hubungi Kami',
  'components.rightContent.organisationSwitcher.defaultLabel': 'Organisasi',
  'components.rightContent.organisationSwitcher.switchError': 'Gagal beralih organisasi',
  'components.rightContent.organisationSwitcher.switching': 'Beralih organisasi...',
  'components.rightContent.organisationSwitcher.tooltipFallback': 'Beralih Organisasi',
  'components.rightContent.organisationSwitcher.unknownOrg': 'Organisasi Tidak Diketahui',
  'components.rightContent.receiptModal.description': 'Laporan Anda telah berhasil dikirim.',
  'components.rightContent.receiptModal.title': 'Terima kasih',
  'components.rightContent.reportBug.browser.arc': 'Arc',
  'components.rightContent.reportBug.browser.brave': 'Brave',
  'components.rightContent.reportBug.browser.chrome': 'Chrome',
  'components.rightContent.reportBug.browser.edge': 'Edge',
  'components.rightContent.reportBug.browser.firefox': 'Firefox',
  'components.rightContent.reportBug.browser.opera': 'Opera',
  'components.rightContent.reportBug.browser.other': 'Lainnya',
  'components.rightContent.reportBug.browser.safari': 'Safari',
  'components.rightContent.reportBug.browserLabel': 'Browser',
  'components.rightContent.reportBug.browserPlaceholder': 'Pilih Browser',
  'components.rightContent.reportBug.browserRequired': 'Silakan tentukan browser Anda',
  'components.rightContent.reportBug.bugDescriptionSectionTitle': 'Deskripsi Bug',
  'components.rightContent.reportBug.contactSectionTitle': 'Kontak',
  'components.rightContent.reportBug.descriptionLabel': 'Jelaskan masalahnya',
  'components.rightContent.reportBug.descriptionRequired': 'Silakan jelaskan masalahnya',
  'components.rightContent.reportBug.deviceLabel': 'Perangkat',
  'components.rightContent.reportBug.devicePlaceholder': 'MacBook Pro M1 2021',
  'components.rightContent.reportBug.deviceRequired': 'Mohon isi perangkat Anda',
  'components.rightContent.reportBug.emailInvalid': 'Mohon masukkan email yang valid',
  'components.rightContent.reportBug.emailLabel': 'Email',
  'components.rightContent.reportBug.emailPlaceholder': 'Masukkan email Anda',
  'components.rightContent.reportBug.emailRequired': 'Mohon masukkan email Anda',
  'components.rightContent.reportBug.environmentSectionTitle': 'Lingkungan',
  'components.rightContent.reportBug.fileSizeKb': '{size} KB',
  'components.rightContent.reportBug.fileUploadError': 'Gagal mengunggah file',
  'components.rightContent.reportBug.fileUploadSuccess': 'File "{fileName}" berhasil diunggah!',
  'components.rightContent.reportBug.filesLabel': 'Tangkapan Layar atau Rekaman',
  'components.rightContent.reportBug.invalidFileType':
    'Anda hanya dapat mengunggah file gambar atau video!',
  'components.rightContent.reportBug.label': 'Laporkan bug',
  'components.rightContent.reportBug.locationLabel': 'Di mana bug ditemukan?',
  'components.rightContent.reportBug.locationPlaceholder': 'Pilih Fungsi',
  'components.rightContent.reportBug.locationRequired': 'Mohon tentukan lokasi ditemukannya bug',
  'components.rightContent.reportBug.namePlaceholder': 'Masukkan nama Anda',
  'components.rightContent.reportBug.nameRequired': 'Mohon masukkan nama Anda',
  'components.rightContent.reportBug.osLabel': 'Sistem operasi dan versi',
  'components.rightContent.reportBug.osPlaceholder': 'macOS Sequoia 15.1',
  'components.rightContent.reportBug.osRequired': 'Mohon tentukan sistem operasi Anda',
  'components.rightContent.reportBug.page.chat': 'Chat',
  'components.rightContent.reportBug.page.composer': 'Composer',
  'components.rightContent.reportBug.page.files': 'File',
  'components.rightContent.reportBug.page.home': 'Beranda',
  'components.rightContent.reportBug.page.other': 'Lainnya',
  'components.rightContent.reportBug.page.reference': 'Referensi',
  'components.rightContent.reportBug.page.review': 'Review',
  'components.rightContent.reportBug.page.userProfile': 'Profil Pengguna',
  'components.rightContent.reportBug.removeFile': 'Hapus {fileName}',
  'components.rightContent.reportBug.submitError': 'Gagal mengirim laporan bug. Silakan coba lagi.',
  'components.rightContent.reportBug.submitSuccess': 'Laporan bug berhasil dikirim!',
  'components.rightContent.reportBug.uploadText': 'Klik atau seret untuk mengunggah',
  'components.rightContent.userGuideButton.label': 'A&GEL Insider',
  'components.scribe.clickToStartRecording': 'Klik untuk mulai merekam',
  'components.scribe.failedToGetAuthToken': 'Gagal mendapatkan token autentikasi',
  'components.scribe.failedToStartRecording': 'Gagal memulai perekaman',
  'components.searchPdfViewerWithHighlight.renderError': 'Gagal menampilkan PDF',
  'components.themeToggle.darkMode': 'Gelap',
  'components.themeToggle.lightMode': 'Terang',
  'components.themeToggle.modeSectionLabel': 'MODE',
  'components.themeToggle.themeMaroon': '🍷 Marun',
  'components.themeToggle.themeSectionLabel': 'TEMA',
  'components.themeToggle.themeSettingsTooltip': 'Pengaturan tema',
  'components.themeToggle.themeTeal': '🌊 Toska',
  'components.whatsNewModal.title': 'Yang Baru',
  'components.whatsNewModal.intro':
    'Kami telah menghadirkan beberapa fitur baru untuk meningkatkan proses tinjauan dokumen Anda:',
  'components.whatsNewModal.feature1.title': 'Penyaringan yang Ditingkatkan: ',
  'components.whatsNewModal.feature1.description':
    'Filter audiens dan penulis baru untuk membantu Anda menemukan daftar pertanyaan lebih cepat.',
  'components.whatsNewModal.feature2.title': 'Pertanyaan Ad-hoc: ',
  'components.whatsNewModal.feature2.description':
    'Cara yang lebih fleksibel untuk menambahkan pertanyaan secara langsung.',
  'components.whatsNewModal.feature3.title': 'Peningkatan UI: ',
  'components.whatsNewModal.feature3.description':
    'Antarmuka yang lebih bersih dan intuitif untuk mengelola {featureName} Anda.',
  'components.whatsNewModal.upcomingFeatures.title': 'Fitur Mendatang',
  'components.whatsNewModal.upcomingFeatures.description':
    'Nantikan pembaruan lainnya, termasuk tinjauan kolaboratif dan analitik AI tingkat lanjut.',
  'components.user.uidLabel': 'UID',
  'components.user.idCopiedMessage': 'ID disalin!',
  'components.file.manager.fetchGroupError': 'Gagal mengambil grup: {message}',
  'components.file.manager.fetchFilesError': 'Gagal mengambil file: {message}',
  'components.file.manager.breadcrumbRoot': 'rute',
  'components.file.manager.breadcrumbBackUpLevel': 'kembali satu tingkat',
  'components.file.manager.searchPlaceholder': 'cari file atau folder',
  'components.file.manager.uploadFileButton': 'Unggah File',
  'components.file.manager.createFolderButton': 'Buat Folder',
  'components.file.manager.enterButton': 'Masuk',
  'components.file.manager.deleteFolderButton': 'Hapus Folder',
  'components.file.manager.deleteFileButton': 'Hapus File',
  'components.file.manager.uploadedByTime': 'Diunggah oleh: {username}, Waktu Unggah: {createdAt}',
  'components.file.manager.folderNamePlaceholder': 'Nama Folder',
  'components.file.filePreview.cannotPreview': 'Jenis file ini tidak dapat dipratinjau',
  'components.file.documentSelector.sortNameAsc': 'Nama (A-Z)',
  'components.file.documentSelector.sortNameDesc': 'Nama (Z-A)',
  'components.file.documentSelector.sortNewestFirst': 'Terbaru lebih dahulu',
  'components.file.documentSelector.sortOldestFirst': 'Terlama lebih dahulu',
  'components.file.documentSelector.favourites': 'Favorit',
  'components.file.documentSelector.selectedCount': 'Dipilih ({count}):',
  'components.file.documentSelector.selectAllFilesInFolder': 'Pilih semua file di {folderName}',
  'components.file.documentSelector.noFiles': 'Tidak ada file',
  'components.file.documentSelector.folderAlt': 'folder',
  'components.file.documentSelector.fileAlt': 'file',
  'components.file.documentSelector.selectDocuments': 'Pilih dokumen',
  'components.file.documentSelector.selectOkText': 'Pilih',
  'components.file.fileTree.uploadFailed': 'Unggah {fileName} gagal',
  'components.file.fileTree.clickOrDragToUpload': 'Klik atau seret untuk mengunggah',
  'components.file.fileTree.noFilesUploadedOrSelected':
    'Belum ada file yang diunggah atau dipilih.',
  'components.file.selectContext.cannotDeleteDefaultContext':
    'Anda tidak dapat menghapus konteks default. Tetapkan konteks lain sebagai default terlebih dahulu.',
  'components.file.selectContext.contextDeleted': 'Konteks dihapus',
  'components.file.selectContext.deleteContextFailed': 'Gagal menghapus konteks',
  'components.file.selectContext.enterContextNameWarning': 'Silakan masukkan nama konteks',
  'components.file.selectContext.contextCreated': 'Konteks dibuat',
  'components.file.selectContext.cannotUnsetDefaultContext':
    'Anda tidak dapat membatalkan konteks default. Tetapkan konteks lain sebagai default terlebih dahulu.',
  'components.file.selectContext.contextUpdated': 'Konteks diperbarui',
  'components.file.selectContext.createContextFailed': 'Gagal membuat konteks',
  'components.file.selectContext.updateContextFailed': 'Gagal memperbarui konteks',
  'components.file.selectContext.selectContextPresetPlaceholder': 'Pilih preset konteks',
  'components.file.selectContext.defaultLabel': '(default)',
  'components.file.selectContext.deleteContextConfirmTitle': 'Hapus konteks ini?',
  'components.file.selectContext.deleteContextConfirmDescription':
    'Tindakan ini tidak dapat dibatalkan.',
  'components.file.selectContext.addNewContextTooltip': 'Tambah konteks baru',
  'components.file.selectContext.modifyContextInfoTooltip': 'Ubah info konteks',
  'components.file.selectContext.newContextLabel': 'Konteks baru',
  'components.file.selectContext.editContextLabel': 'Edit konteks',
  'components.file.selectContext.contextTitlePlaceholder': 'Judul konteks',
  'components.file.selectContext.setAsDefaultLabel': 'Jadikan default',
  'components.file.selectContext.contextSelectionTitle': 'Pemilihan konteks',
  'components.file.selectContext.noContextSelected': 'Tidak Ada Konteks yang Dipilih',
  'components.billingRequiredOverlay.defaultMessage':
    'Penagihan organisasi Anda memerlukan perhatian sebelum tindakan ini dapat dilanjutkan. Silakan hubungi admin organisasi Anda.',
  'components.chatWidget.waitingMessage.hangTight':
    'Tunggu sebentar, saya sedang mengerjakannya...',
  'components.questionListSelection.whatsNewButton': 'Yang Baru',
  'components.reference.timeAgo.minutesAgo': '{count, plural, other {# menit yang lalu}}',
  'components.reference.matrixIdRequired':
    'ID Matrix diperlukan. Pastikan prop matrixId diteruskan ke komponen Reference.',
  'components.reference.cellsSelected': '{count, plural, other {# sel dipilih.}}',
  'components.rightContent.organisationSwitcher.switchSuccess': 'Berhasil beralih organisasi',
  'components.rightContent.organisationSwitcher.switchNoToken':
    'Peralihan organisasi tidak mengembalikan token baru',
  'components.rightContent.reportBug.modalDescription':
    'Beri tahu kami apa yang Anda alami dengan mengisi formulir di bawah ini.',
  'components.appShell.logoutMenuItem': 'Keluar',
  'components.appShell.unauthorized.title': 'Halaman ini bukan untuk Anda',
  'components.appShell.unauthorized.backHome': 'Kembali ke Beranda',
  'components.appShell.promptLibrary.title': 'Perpustakaan Prompt',
  'components.appShell.promptLibrary.noPromptsAvailable': 'Tidak ada prompt yang tersedia',
  'components.appShell.promptLibrary.copyTooltip': 'Salin konten prompt',
  'components.appShell.promptLibrary.untitledPrompt': 'Prompt Tanpa Judul',
  'components.appShell.promptLibrary.copiedMessage': 'Prompt disalin ke clipboard!',
  'components.appShell.clipboard.title': 'Clipboard',
  'components.appShell.clipboard.copiedMessage': 'Disalin!',
  'components.appShell.notFound.title': 'Halaman ini tidak ada',
  'components.gettingStartedTour.tourTask.chat.title': 'Obrolan',
  'components.gettingStartedTour.tourTask.chat.duration': '~1 mnt',
  'components.gettingStartedTour.tourTask.search.title': 'Pencarian',
  'components.gettingStartedTour.tourTask.search.duration': '~1 mnt',
  'components.gettingStartedTour.tourTask.scribe.title': 'Rekaman',
  'components.gettingStartedTour.tourTask.scribe.duration': '~2 mnt',
  'components.gettingStartedTour.tourTask.review.title': 'Review',
  'components.gettingStartedTour.tourTask.review.duration': '~3 mnt',
  'components.gettingStartedTour.tourTask.playbook.title': 'Workstudio',
  'components.gettingStartedTour.tourTask.playbook.duration': '~2 mnt',
  'components.matrixPolling.processingStoppedMessage': 'Pemrosesan dihentikan',
  'components.matrixPolling.stopProcessingFailedMessage': 'Gagal menghentikan pemrosesan',
  'components.appShell.noResponseError': 'Tidak ada respons! Silakan coba lagi.',
  'components.appShell.requestError': 'Kesalahan permintaan, silakan coba lagi.',
  'components.appShell.requestFailedError': 'Permintaan gagal!',
  'components.composerService.socketErrorPrefix': 'Kesalahan: {message}',
  'components.composerService.sessionDisconnected': 'Sesi Composer terputus karena koneksi lain',
  'components.fileViewerWithToken.retrieveFailedError': 'Gagal mengambil file',
  'components.languageSwitcher.switchLanguageTooltip': 'Ganti bahasa',
  'components.crossOrgBadge.sharedByLabel': 'Dibagikan oleh: {orgName}',
  'components.crossOrgBadge.externalOrganization': 'Organisasi Eksternal',
  'components.file.sharePoint.fromComputer': 'Dari komputer ini',
  'components.file.sharePoint.fromSharePoint': 'Dari SharePoint / OneDrive',
  'components.file.sharePoint.orAddFromSharePoint': 'atau tambahkan dari SharePoint / OneDrive',
  'components.file.sharePoint.account': 'Akun Microsoft',
  'components.file.sharePoint.useDifferentAccount': 'Gunakan akun lain',
  'components.file.sharePoint.disconnect': 'Putuskan',
  'components.file.sharePoint.disconnectConfirm': 'Putuskan akun Microsoft Anda dari A&GEL?',
  'components.file.sharePoint.disconnected': 'Akun Microsoft telah diputuskan.',
  'components.file.sharePoint.popupBlocked':
    'Izinkan pop-up untuk A&GEL agar dapat memilih file dari SharePoint.',
  'components.file.sharePoint.consentDeniedTitle': 'Akses SharePoint tidak disetujui',
  'components.file.sharePoint.consentDenied':
    'Akses SharePoint tidak disetujui. Jika organisasi Anda memerlukan persetujuan admin TI, mintalah admin TI Anda untuk menyetujui A&GEL.',
  'components.file.sharePoint.copyApprovalLink': 'Salin tautan persetujuan untuk admin TI Anda',
  'components.file.sharePoint.approvalLinkCopied': 'Tautan persetujuan disalin.',
  'components.file.sharePoint.connectFailed':
    'Tidak dapat terhubung ke Microsoft. Silakan coba lagi.',
  'components.file.sharePoint.reconnect': 'Silakan hubungkan ulang akun Microsoft Anda.',
  'components.file.sharePoint.unsupportedType': '{name} bukan jenis file yang didukung di sini.',
  'components.file.sharePoint.tooLarge': '{name} terlalu besar (maks. {max} MB).',
  'components.file.sharePoint.rejected': '{name} tidak dapat ditambahkan.',
  'components.file.sharePoint.downloadFailed':
    'Tidak dapat mengambil {name} dari SharePoint. Silakan coba lagi atau unggah dari komputer Anda.',
  'components.file.sharePoint.folderTooLarge':
    'Folder ini terlalu besar untuk diimpor sekaligus (maks. {max} file). Silakan pilih folder yang lebih kecil.',
  'components.file.sharePoint.chooserTitle': 'Pilih file',
  'components.file.sharePoint.chooserMyFiles': 'File saya',
  'components.file.sharePoint.chooserShared': 'Dibagikan',
  'components.file.sharePoint.chooserFollowedSites': 'Situs yang diikuti',
  'components.file.sharePoint.chooserSearch': 'Cari situs',
  'components.file.sharePoint.chooserName': 'Nama',
  'components.file.sharePoint.chooserEmpty':
    'Anda belum mengikuti situs apa pun. Cari situs di atas.',
  'components.file.sharePoint.chooserLocked':
    'Hanya situs yang Anda ikuti atau cari yang ditampilkan. Minta admin TI Anda menyetujui A&GEL agar Anda dapat menelusuri semua situs.',
  'components.file.sharePoint.chooserLoading': 'Memuat…',
  'components.file.sharePoint.chooserSelect': 'Pilih',
  'components.file.sharePoint.chooserCancel': 'Batal',
};
